<template>
	<NP-Modal :toggle="toggle" label="Створити ордер" variant="sidebar">
		<form @submit.prevent="apply">
			<div class="orders-form">
				<h4>Тип ордера</h4>
				<div class="order-controls">
					<NP-ButtonSwitch
						class="cashbook-order-type-btn"
						:options="[...lists['cashbook-order-types']].reverse().map((i) => ({ ...i, text: i.text.toUpperCase() }))"
						v-model="order_type"
						:disabled="true"
					/>
					<NP-Select
						id="cashbook-order-sub-type"
						class="cashbook-order-sub-type"
						:label="`Тип прибуткового ордеру`"
						:options="orderSubTypeOptions"
						v-model="order_sub_type"
						:disabled="true"
					/>
				</div>
				<div class="cashbook-order-create-again" v-if="showCreateAgain">
					<span class="confirm-icon" />
					<span>Ордер збережено, тепер створи ще один</span>
				</div>
				<CashFromCourierForm v-model="formData" :orders-left="ordersLeft" :lists="lists" />
			</div>
			<div class="buttons">
				<NP-Button type="button" priority="low-borderless" @click.stop="toggle">
					<div slot="icon" class="icon-close" />
					Скасувати
				</NP-Button>
				<NP-Button
					type="submit"
					priority="high"
					:disabled="disabledSave"
					:loading="loadingActions.includes('createCashFromCourier')"
				>
					Зберегти
				</NP-Button>
			</div>
		</form>
	</NP-Modal>
</template>

<script>
import find from 'lodash/find';
import CashFromCourierForm from '../../../orders/components/order-sidebar/cash-from-courier.vue';

import { enum as cashbookOrderSubTypes } from '@repo/enums/cashbook-order-sub-types';
import { enum as cashbookOrderTypes } from '@repo/enums/cashbook-order-types';
import { enum as cashbookOrderStatuses } from '@repo/enums/cashbook-order-statuses';

export default {
	name: 'CashdeskCourierOrderModal',
	components: {
		CashFromCourierForm
	},
	props: {
		toggle: { type: Function, default: null },
		create: { type: Function, default: null },
		updatePendingOrders: { type: Function, default: null },
		lists: { type: Object, default: () => ({}) },
		loadingActions: { type: Array, default: () => [] },
		pendingOrders: { type: Array, default: () => [] },
		cashdesk: { type: Object, default: () => null }
	},
	data() {
		let order_sub_type = find(this.lists['cashbook-order-sub-types'], {
			id: cashbookOrderSubTypes.cashFromCourier
		});
		let order_type = cashbookOrderTypes.incoming;
		return {
			cashbookOrderSubTypes,
			cashbookOrderTypes,
			cashbookOrderStatuses,
			order_type,
			order_sub_type,
			controlsDisabled: false,
			formData: null,
			processedOrdersIds: []
		};
	},
	computed: {
		disabledSave() {
			return !this.formData || !this.formData.amount;
		},
		orderSubTypeOptions() {
			let allowedTypes = [cashbookOrderSubTypes.cashFromCourier];
			return this.lists['cashbook-order-sub-types'].filter((row) => allowedTypes.includes(row.id));
		},
		ordersLeft() {
			return (
				!!this.pendingOrders &&
				this.pendingOrders.filter(
					(o) =>
						o.sub_type === cashbookOrderSubTypes.cashToCourier &&
						o.participant_id === this.cashdesk.user_id &&
						!this.processedOrdersIds.includes(o.id)
				)
			);
		},
		showCreateAgain() {
			return this.ordersLeft && this.processedOrdersIds.length;
		}
	},
	methods: {
		async apply() {
			let data = {
				...this.formData,
				type: this.order_sub_type?.id,
				loadingAction: true,
				cb: (res) => {
					if (res.status === 200) {
						this.processedOrdersIds.push(this.formData.sender_order_id);
						this.updatePendingOrders({
							id: this.formData.sender_order_id,
							status: cashbookOrderStatuses.confirmed
						});
					}
				}
			};

			if ((!!this.ordersLeft && !this.ordersLeft?.length) || this.ordersLeft.length === 1) {
				data.is_last_order = true;
			}

			this.create(data);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/mixins';
@import '@assets/scss/variables';

$icon-close: '~@assets/images/icon-close.svg';
$icon-confirm: '~@assets/images/icon-confirm.svg';

::v-deep .modal-container {
	display: flex;
	flex-direction: column;
	.modal-body {
		flex: 1;
		form {
			width: 550px;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			margin-right: 10px;
			.orders-form {
				flex: 1;
				display: flex;
				flex-direction: column;
				.button-switch {
					min-height: 42px;
				}
				h4 {
					font-family: Proxima Nova Semibold;
					color: $gray-50;
					font-size: 14px;
					margin-bottom: 12px;
				}
				.order-controls {
					display: flex;
					width: 100%;
					margin-bottom: 24px;
					padding-bottom: 24px;
					position: relative;
					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						width: calc(100% + 58px);
						height: 1px;
						left: -24px;
						background: $gray-10;
					}
					.cashbook-order-type-btn {
						margin-right: 16px;
					}
				}
				.cashbook-order-sub-type {
					width: 100%;
				}
				.cashbook-order-create-again {
					display: flex;
					align-items: center;
					gap: 12px;
					padding: 12px;
					background-color: #dcf2e5;
					border-radius: 4px;
					margin-bottom: 24px;

					span {
						color: $green;
						font-weight: 600;
						font-size: 12px;
					}
					.confirm-icon {
						@include make-icon($icon-confirm, $green, 20px, 20px);
					}
				}
			}
			.buttons {
				width: 100%;
				padding-top: 24px;
				display: flex;
				justify-content: flex-end;
				.button {
					margin-right: 24px;
					&:last-child {
						margin: 0;
					}
				}
				.icon-close {
					@include make-icon($icon-close, $gray-50, 20px, 20px);
				}
			}
		}
	}
}
</style>
